import { z } from 'zod';

/**
 * The systems whose signed-in users may call the API with their own access token (QZ-D180).
 * A token's `iss` is matched against them in this order, so `quizdb` comes first.
 */
export const ISSUERS = ['quizdb', 'gquiz'] as const;
export const issuerSchema = z.enum(ISSUERS);
export type Issuer = z.infer<typeof issuerSchema>;
